<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT">NOTE</div>
<div class="fmtx1">The title of this book was <br/>suggested by Herbert Mitgang, <br/>who experienced World War Two <br/>as an army correspondent. It is a phrase <br/>that has been frequently voiced by <br/>men of his and my generation, <br/>to distinguish that war from other <br/>wars, declared and undeclared. <br/>Quotation marks have been added, <br/>not as a matter of caprice or <br/>editorial comment, but simply <br/>because the adjective “good” mated <br/>to the noun “war” is so <br/>incongruous.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587596_oeb_fm1_r1.vue?125af2e4